export const attributes = Object.freeze({
  POWER: 'Moc',
  CROSS_SECTION: 'Przekrój',
});
